export default {"src":"/_next/static/media/information.1f2c12b4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};